import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import LoginShell, { emailPflichtFehler, feldAngaben, LoginFeldFehler, pruefeFelder, type FeldFehlerListe } from '../components/LoginShell';
import apiClient from '../services/apiClient';
import { API_ENDPOINTS } from '../config/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [feldfehler, setFeldfehler] = useState<FeldFehlerListe>({});
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const fehler = pruefeFelder({ email: emailPflichtFehler(email) });
    setFeldfehler(fehler);
    if (Object.keys(fehler).length) return;
    setLoading(true); setError('');
    try { await apiClient.post(API_ENDPOINTS.FORGOT_PASSWORD, { email }); setSubmitted(true); }
    catch (err: any) { setError(err.response?.data?.error || 'Die Anfrage konnte nicht gesendet werden.'); }
    finally { setLoading(false); }
  };
  return (
    <LoginShell>
      <div className="login-form-wrap">
        {submitted ? <>
          <div className="login-result" role="status">
            <CheckIcon className="login-result-icon" aria-hidden="true" />
            <h1 id="auth-title">Prüfen Sie Ihr Postfach.</h1>
            <p className="login-intro">Falls ein Konto für diese E-Mail-Adresse besteht, erhalten Sie einen Link, mit dem Sie ein neues Passwort festlegen können.</p>
          </div>
          <Link to="/login" className="login-submit"><span>Zur Anmeldung</span><ArrowRightIcon aria-hidden="true" /></Link>
        </> : <>
          <Link to="/login" className="login-back"><ArrowLeftIcon aria-hidden="true" />Zur Anmeldung</Link>
          <h1 id="auth-title">Passwort vergessen?</h1>
          <p className="login-intro">Geben Sie die E-Mail-Adresse Ihres CLAiRIS-Kontos ein, um einen Link zum Zurücksetzen anzufordern.</p>
          <form onSubmit={handleSubmit} noValidate className="login-form" aria-label="Passwort zurücksetzen" aria-busy={loading} aria-describedby={error ? 'recovery-error' : undefined}>
            <div className="login-field">
              <label htmlFor="email">E-Mail-Adresse</label>
              <input {...feldAngaben('email', feldfehler)} name="email" type="email" value={email} onChange={(e) => { setEmail(e.target.value); setFeldfehler({}); }} placeholder="name@unternehmen.at" required autoComplete="email" autoCapitalize="none" spellCheck={false} />
              <LoginFeldFehler id="email" fehler={feldfehler} />
            </div>
            {error && <div id="recovery-error" className="login-notice error" role="alert"><strong>Anfrage nicht möglich.</strong><span>{error}</span></div>}
            <button type="submit" disabled={loading} className="login-submit"><span>{loading ? 'Link wird angefordert …' : 'Link anfordern'}</span><ArrowRightIcon aria-hidden="true" /></button>
          </form>
        </>}
      </div>
    </LoginShell>
  );
}
export default ForgotPassword;
